/* ============================================
   Ruvity — Theme JavaScript
   Vanilla JS, no dependencies
   ============================================ */

(function () {
  'use strict';

  /* -----------------------------------------
     Accordion
  ----------------------------------------- */
  function initAccordions() {
    var triggers = document.querySelectorAll('[data-accordion-trigger]');

    triggers.forEach(function (trigger) {
      trigger.addEventListener('click', function () {
        var content = document.getElementById(trigger.getAttribute('aria-controls'));
        if (!content) return;

        var expanded = trigger.getAttribute('aria-expanded') === 'true';

        // Close sibling accordions within the same group
        var group = trigger.closest('[data-accordion-group]');
        if (group) {
          group.querySelectorAll('[data-accordion-trigger]').forEach(function (sibling) {
            if (sibling !== trigger) {
              sibling.setAttribute('aria-expanded', 'false');
              var siblingContent = document.getElementById(sibling.getAttribute('aria-controls'));
              if (siblingContent) siblingContent.setAttribute('aria-hidden', 'true');
            }
          });
        }

        trigger.setAttribute('aria-expanded', expanded ? 'false' : 'true');
        content.setAttribute('aria-hidden', expanded ? 'true' : 'false');
      });
    });
  }

  /* -----------------------------------------
     Quantity Selectors
  ----------------------------------------- */
  function initQuantitySelectors() {
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-quantity-change]');
      if (!btn) return;

      var container = btn.closest('[data-quantity]');
      if (!container) return;

      var input = container.querySelector('[data-quantity-input]');
      if (!input) return;

      var current = parseInt(input.value, 10) || 1;
      var min = parseInt(input.min, 10) || 1;
      var max = parseInt(input.max, 10) || 99;
      var direction = btn.getAttribute('data-quantity-change');

      if (direction === 'increment' && current < max) {
        input.value = current + 1;
      } else if (direction === 'decrement' && current > min) {
        input.value = current - 1;
      }

      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }

  /* -----------------------------------------
     Variant Selector
  ----------------------------------------- */
  function initVariantSelectors() {
    var productForms = document.querySelectorAll('[data-product-form]');

    productForms.forEach(function (form) {
      var jsonEl = form.querySelector('[data-product-json]');
      if (!jsonEl) return;

      var productData;
      try {
        productData = JSON.parse(jsonEl.textContent);
      } catch (e) {
        return;
      }
      var variants = productData.variants;

      var optionButtons = form.querySelectorAll('[data-option-select]');
      var section = form.closest('section') || form.parentElement;
      var priceEl = section.querySelector('[data-product-price]');
      var comparePriceEl = section.querySelector('[data-product-compare-price]');
      var addBtn = form.querySelector('[data-add-to-cart]');
      var variantInput = form.querySelector('input[name="id"]');
      var mainImage = document.querySelector('[data-product-main-image]');
      var savingsBadge = section.querySelector('[data-savings-badge]');

      optionButtons.forEach(function (btn) {
        btn.addEventListener('click', function () {
          // Update active state for this option group
          var optionIndex = btn.getAttribute('data-option-index');
          var siblings = form.querySelectorAll('[data-option-select][data-option-index="' + optionIndex + '"]');
          siblings.forEach(function (s) {
            s.classList.remove('variant-toggle__btn--active', 'variant-pill--active');
            s.setAttribute('aria-pressed', 'false');
          });
          btn.classList.add(btn.classList.contains('variant-toggle__btn') ? 'variant-toggle__btn--active' : 'variant-pill--active');
          btn.setAttribute('aria-pressed', 'true');

          // Gather selected options from active buttons
          var selectedOptions = [];
          var optionGroups = form.querySelectorAll('.variant-selector');
          optionGroups.forEach(function (group) {
            var active = group.querySelector('[data-option-select][aria-pressed="true"]');
            if (active) {
              selectedOptions.push(active.getAttribute('data-option-value'));
            }
          });

          var matchedVariant = variants.find(function (v) {
            return v.options.every(function (opt, i) {
              return opt === selectedOptions[i];
            });
          });

          if (matchedVariant) {
            // Update hidden input
            if (variantInput) variantInput.value = matchedVariant.id;

            // Update price
            if (priceEl) {
              priceEl.innerHTML = formatMoney(matchedVariant.price);
            }
            if (comparePriceEl) {
              if (matchedVariant.compare_at_price && matchedVariant.compare_at_price > matchedVariant.price) {
                comparePriceEl.innerHTML = '<s>' + formatMoney(matchedVariant.compare_at_price) + '</s>';
                comparePriceEl.style.display = '';
              } else {
                comparePriceEl.style.display = 'none';
              }
            }

            // Update availability
            if (addBtn) {
              if (matchedVariant.available) {
                addBtn.disabled = false;
                addBtn.textContent = addBtn.getAttribute('data-add-text') || 'Add to Cart';
              } else {
                addBtn.disabled = true;
                addBtn.textContent = addBtn.getAttribute('data-sold-out-text') || 'Sold Out';
              }
            }

            // Update URL
            if (matchedVariant.id) {
              var url = new URL(window.location);
              url.searchParams.set('variant', matchedVariant.id);
              window.history.replaceState({}, '', url);
            }

            // Update main image
            if (mainImage && matchedVariant.featured_image) {
              mainImage.src = matchedVariant.featured_image.src;
              mainImage.alt = matchedVariant.featured_image.alt || '';
            }

            // Savings badge: dynamically detect option schema and compute savings
            if (savingsBadge) {
              // Detect option schema: new (Duration/Patient Type) vs old (Dosage/Supply)
              var isNewSchema = variants.some(function (v) {
                return v.options.indexOf('30 Day') !== -1 || v.options.indexOf('90 Day') !== -1;
              });

              var showBadge = false;
              var savings = 0;

              if (isNewSchema) {
                // New schema: option[0] = Duration, option[1] = Patient Type
                var duration = matchedVariant.options[0];
                var patientType = matchedVariant.options[1];

                if (duration === '90 Day') {
                  var shortVariant = variants.find(function (v) {
                    return v.options[0] === '30 Day' && v.options[1] === patientType;
                  });
                  if (shortVariant) {
                    savings = (shortVariant.price * 3) - matchedVariant.price;
                    showBadge = savings > 0;
                  }
                }
              } else {
                // Old schema: option[0] = Dosage, option[1] = Supply
                var supplyOption = matchedVariant.options[1];
                var dosageOption = matchedVariant.options[0];

                if (supplyOption === '3 Month') {
                  var monthlyVariant = variants.find(function (v) {
                    return v.options[0] === dosageOption && v.options[1] === '1 Month';
                  });
                  if (monthlyVariant) {
                    savings = (monthlyVariant.price * 3) - matchedVariant.price;
                    showBadge = savings > 0;
                  }
                }
              }

              if (showBadge) {
                savingsBadge.textContent = 'Save ' + formatMoney(savings);
                savingsBadge.style.display = '';
              } else {
                savingsBadge.style.display = 'none';
              }
            }
          }
        });
      });
    });
  }

  function formatMoney(cents) {
    var format = window.theme && window.theme.moneyFormat ? window.theme.moneyFormat : '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    var amountWithComma = amount.replace(/\B(?=(\d{3})+(?!\d))/g, '.').replace(/\.(\d{2})$/, ',$1');
    var noDecimalsWithComma = Math.round(cents / 100).toString().replace(/\B(?=(\d{3})+(?!\d))/g, '.');
    return format
      .replace('{{amount_no_decimals_with_comma_separator}}', noDecimalsWithComma)
      .replace('{{amount_with_comma_separator}}', amountWithComma)
      .replace('{{amount_no_decimals}}', Math.round(cents / 100))
      .replace('{{amount}}', amount);
  }

  /* -----------------------------------------
     Scroll-Triggered Animations
  ----------------------------------------- */
  function initScrollAnimations() {
    var selector = '.reveal, .fade-in';

    // Respect prefers-reduced-motion
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      document.querySelectorAll(selector).forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    if (!('IntersectionObserver' in window)) {
      // Fallback: show everything immediately
      document.querySelectorAll(selector).forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { threshold: 0.15, rootMargin: '0px 0px -60px 0px' }
    );

    document.querySelectorAll(selector).forEach(function (el) {
      observer.observe(el);
    });
  }

  /* -----------------------------------------
     Parallax Scrolling
  ----------------------------------------- */
  function initParallax() {
    if (window.innerWidth < 768) return;

    var elements = document.querySelectorAll('[data-parallax]');
    if (!elements.length) return;

    var ticking = false;

    function update() {
      elements.forEach(function (el) {
        var speed = parseFloat(el.dataset.parallax) || 0.15;
        var rect = el.getBoundingClientRect();
        var yOffset = (rect.top - window.innerHeight / 2) * speed;
        el.style.transform = 'translate3d(0, ' + yOffset + 'px, 0)';
      });
      ticking = false;
    }

    window.addEventListener('scroll', function () {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }, { passive: true });
  }

  /* -----------------------------------------
     Counter Animation
  ----------------------------------------- */
  function initCounterAnimation() {
    var counters = document.querySelectorAll('[data-counter]');
    if (!counters.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var el = entry.target;
          var target = parseInt(el.textContent.replace(/[^0-9]/g, ''), 10);
          if (isNaN(target)) return;

          var duration = 2000;
          var start = performance.now();

          function easeOutQuart(t) {
            return 1 - Math.pow(1 - t, 4);
          }

          function step(now) {
            var progress = Math.min((now - start) / duration, 1);
            var value = Math.round(easeOutQuart(progress) * target);
            el.textContent = value > 999 ? value.toLocaleString() : value;
            if (progress < 1) requestAnimationFrame(step);
          }

          requestAnimationFrame(step);
          observer.unobserve(el);
        }
      });
    }, { threshold: 0.5 });

    counters.forEach(function (el) {
      observer.observe(el);
    });
  }

  /* -----------------------------------------
     Scroll Header
  ----------------------------------------- */
  function initScrollHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;

    window.addEventListener('scroll', function () {
      if (window.scrollY > 72) {
        header.classList.add('header--scrolled');
      } else {
        header.classList.remove('header--scrolled');
      }
    }, { passive: true });
  }

  /* -----------------------------------------
     Smooth Scroll for Anchors
  ----------------------------------------- */
  function initSmoothScroll() {
    document.addEventListener('click', function (e) {
      var link = e.target.closest('a[href^="#"]');
      if (!link) return;

      var target = document.querySelector(link.getAttribute('href'));
      if (!target) return;

      e.preventDefault();
      target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    });
  }

  /* -----------------------------------------
     Product Image Gallery
  ----------------------------------------- */
  function initProductGallery() {
    var thumbnails = document.querySelectorAll('[data-thumbnail]');
    var mainImage = document.querySelector('[data-product-main-image]');

    if (!mainImage || thumbnails.length === 0) return;

    thumbnails.forEach(function (thumb) {
      thumb.addEventListener('click', function (e) {
        e.preventDefault();

        // Update main image
        mainImage.src = thumb.getAttribute('data-full-src');
        mainImage.alt = thumb.getAttribute('data-alt') || '';

        // Update active state
        thumbnails.forEach(function (t) {
          t.classList.remove('is-active');
        });
        thumb.classList.add('is-active');
      });
    });
  }

  /* -----------------------------------------
     Tabs
  ----------------------------------------- */
  function initTabs() {
    var tabGroups = document.querySelectorAll('[data-tabs]');

    tabGroups.forEach(function (group) {
      var tabs = group.querySelectorAll('[data-tab]');
      var panels = group.querySelectorAll('[data-tab-panel]');

      tabs.forEach(function (tab) {
        tab.addEventListener('click', function () {
          var target = tab.getAttribute('data-tab');

          tabs.forEach(function (t) {
            t.classList.remove('is-active');
            t.setAttribute('aria-selected', 'false');
          });
          panels.forEach(function (p) { p.classList.remove('is-active'); p.setAttribute('hidden', ''); });

          tab.classList.add('is-active');
          tab.setAttribute('aria-selected', 'true');
          var panel = group.querySelector('[data-tab-panel="' + target + '"]');
          if (panel) { panel.classList.add('is-active'); panel.removeAttribute('hidden'); }
        });
      });
    });
  }

  /* -----------------------------------------
     Card Variant Selectors (collection page)
  ----------------------------------------- */
  function initCardVariantSelectors() {
    document.querySelectorAll('[data-card-quick-select]').forEach(function (card) {
      var jsonEl = card.querySelector('[data-card-product-json]');
      if (!jsonEl) return;

      var productData;
      try { productData = JSON.parse(jsonEl.textContent); } catch (e) { return; }
      var variants = productData.variants;
      var selects = card.querySelectorAll('[data-card-option]');
      var variantInput = card.querySelector('[data-card-variant-id]');

      selects.forEach(function (select) {
        select.addEventListener('change', function () {
          var selectedOptions = [];
          selects.forEach(function (s) { selectedOptions.push(s.value); });

          var matched = variants.find(function (v) {
            return v.options.every(function (opt, i) { return opt === selectedOptions[i]; });
          });

          if (matched && variantInput) {
            variantInput.value = matched.id;
          }
        });
      });
    });
  }

  /* -----------------------------------------
     Init
  ----------------------------------------- */
  document.addEventListener('DOMContentLoaded', function () {
    initAccordions();
    initQuantitySelectors();
    initVariantSelectors();
    initScrollAnimations();
    initSmoothScroll();
    initProductGallery();
    initTabs();
    initParallax();
    initCounterAnimation();
    initScrollHeader();
    initCardVariantSelectors();
  });
})();
